import {
  getInboxes,
  getInbox,
  updateInbox,
  createTelegramInbox,
  createMaxInbox,
  createWebWidgetInbox,
  createVkInbox,
  deleteInbox,
} from '@/api/inboxes'
import { resolveAccountId } from '@/store/helpers/account'

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
}

export const getters = {
  getInboxes: $state => $state.records,
  getInboxById: $state => id => $state.records.find(inbox => inbox.id === id),
  getUIFlags: $state => $state.uiFlags,
}

export const actions = {
  async get({ commit, dispatch, rootGetters }) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    if (!accountId) return
    commit('SET_UI_FLAG', { isFetching: true })
    try {
      const { data } = await getInboxes(accountId)
      commit('SET_INBOXES', data)
    } finally {
      commit('SET_UI_FLAG', { isFetching: false })
    }
  },

  async createTelegram({ commit, dispatch, rootGetters }, payload) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    commit('SET_UI_FLAG', { isCreating: true })
    try {
      const { data } = await createTelegramInbox(accountId, payload)
      commit('ADD_INBOX', data)
      return data
    } finally {
      commit('SET_UI_FLAG', { isCreating: false })
    }
  },

  async show({ commit, dispatch, rootGetters }, id) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    if (!accountId) return null
    const { data } = await getInbox(accountId, id)
    commit('UPDATE_INBOX', data)
    return data
  },

  async update({ commit, dispatch, rootGetters }, { id, ...payload }) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    commit('SET_UI_FLAG', { isUpdating: true })
    try {
      const { data } = await updateInbox(accountId, id, payload)
      commit('UPDATE_INBOX', data)
      return data
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false })
    }
  },

  async createMax({ commit, dispatch, rootGetters }, payload) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    commit('SET_UI_FLAG', { isCreating: true })
    try {
      const { data } = await createMaxInbox(accountId, payload)
      commit('ADD_INBOX', data)
      return data
    } finally {
      commit('SET_UI_FLAG', { isCreating: false })
    }
  },

  async createVk({ commit, dispatch, rootGetters }, payload) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    commit('SET_UI_FLAG', { isCreating: true })
    try {
      const { data } = await createVkInbox(accountId, payload)
      commit('ADD_INBOX', data)
      return data
    } finally {
      commit('SET_UI_FLAG', { isCreating: false })
    }
  },

  async createWebWidget({ commit, dispatch, rootGetters }, payload) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    commit('SET_UI_FLAG', { isCreating: true })
    try {
      const { data } = await createWebWidgetInbox(accountId, payload)
      commit('ADD_INBOX', data)
      return data
    } finally {
      commit('SET_UI_FLAG', { isCreating: false })
    }
  },

  async delete({ commit, dispatch, rootGetters }, id) {
    const accountId = await resolveAccountId({ dispatch, rootGetters })
    commit('SET_UI_FLAG', { isDeleting: true })
    try {
      await deleteInbox(accountId, id)
      commit('DELETE_INBOX', id)
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false })
    }
  },
}

export const mutations = {
  SET_INBOXES($state, records) {
    $state.records = records
  },
  ADD_INBOX($state, record) {
    $state.records = [record, ...$state.records]
  },
  UPDATE_INBOX($state, record) {
    const index = $state.records.findIndex(inbox => inbox.id === record.id)
    if (index === -1) {
      $state.records = [record, ...$state.records]
    } else {
      $state.records.splice(index, 1, record)
    }
  },
  DELETE_INBOX($state, id) {
    $state.records = $state.records.filter(inbox => inbox.id !== id)
  },
  SET_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
